import { Button, Checkbox, Input, Select, Textarea } from '../../../components';
import { useLang } from '../../../i18n';
import ChannelChip from '../../LeadFormModal/components/ChannelChip';
import ChannelInput from '../../LeadFormModal/components/ChannelInput';
import SuccessState from '../../LeadFormModal/components/SuccessState';
import { useLeadForm, type ChannelKind } from '../../LeadFormModal/hooks/useLeadForm';
import '../../LeadFormModal/LeadFormModal.scss';
import './FormSection.scss';

const CHANNEL_ORDER: ChannelKind[] = ['telegram', 'whatsapp', 'phone', 'email'];

export default function FormSection() {
  const { t } = useLang();
  const form = useLeadForm({ open: true, onClose: () => undefined });

  return (
    <section className="section section--tight contacts-form-section">
      <div className="container contacts-form-section__inner">
        <div className="section-header contacts-form-section__head">
          <span className="eyebrow">{t('contacts.form.title')}</span>
          <h2 className="contacts-form-section__title">{t('contacts.form.sub')}</h2>
        </div>

        <div className="card-frame contacts-form-section__card">
          {form.submitted ? (
            <SuccessState
              title={t('lead.success.t')}
              description={t('lead.success.d')}
              telegramUrl="https://t.me/mrbek112"
              whatsappUrl="https://wa.me/998900770302"
              onClose={() => undefined}
              labels={{
                telegram: t('lead.success.tg'),
                whatsapp: t('lead.success.wa'),
                close: t('lead.success.close'),
              }}
            />
          ) : (
            <form className="lead-form" onSubmit={form.submit} noValidate>
              <Input
                label={t('lead.name')}
                value={form.name}
                onChange={(e) => form.setName(e.target.value)}
                placeholder={t('lead.name.ph')}
                required
                minLength={2}
                autoComplete="name"
                error={form.errors.name}
              />

              <Select
                label={t('lead.service')}
                value={form.service}
                onChange={form.setService}
                options={[{ value: '', label: t('lead.service.unsure') }, ...form.services]}
                placeholder={t('lead.service.ph')}
              />

              <div className="lead-form__channels">
                <span className="lead-form__channels-label">{t('lead.channels.title')}</span>
                <div className="lead-form__chips" role="group" aria-label={t('lead.channels.title')}>
                  {CHANNEL_ORDER.map((k) => (
                    <ChannelChip
                      key={k}
                      kind={k}
                      label={t(`lead.channel.${k}`)}
                      active={form.channels.includes(k)}
                      onToggle={form.toggleChannel}
                    />
                  ))}
                </div>
                <div className="lead-form__fields">
                  {CHANNEL_ORDER.map((k) => (
                    <ChannelInput
                      key={k}
                      kind={k}
                      visible={form.channels.includes(k)}
                      value={form.values[k]}
                      onChange={(raw) => form.setChannelValue(k, raw)}
                      error={form.errors[`ch_${k}`]}
                    />
                  ))}
                </div>
              </div>

              <Textarea
                label={t('lead.description')}
                value={form.description}
                onChange={(e) => form.setDescription(e.target.value)}
                placeholder={t('lead.description.ph')}
                rows={4}
                maxHeight={240}
                error={form.errors.description}
              />

              <Select
                label={t('lead.budget')}
                value={form.budget}
                onChange={form.setBudget}
                options={form.budgetOptions}
                placeholder={t('lead.budget.ph')}
              />

              <Checkbox
                label={
                  <span>
                    {t('lead.agree.t')}{' '}
                    <a href="/legal/privacy" target="_blank" rel="noreferrer noopener" className="lead-form__legal-link">
                      {t('lead.agree.link')}
                    </a>
                  </span>
                }
                checked={form.agree}
                onChange={(e) => form.setAgree(e.target.checked)}
                error={form.errors.agree}
              />

              <input
                className="lead-form__honey"
                name="website"
                tabIndex={-1}
                autoComplete="off"
                value={form.honey}
                onChange={(e) => form.setHoney(e.target.value)}
                aria-hidden="true"
              />

              <Button type="submit" variant="primary" size="lg" loading={form.loading} fullWidth>
                {t('lead.submit')}
              </Button>
            </form>
          )}
        </div>
        <small className="contacts-form-section__note">{t('contacts.form.note')}</small>
      </div>
    </section>
  );
}
